import { z } from 'zod';
import { UserResponsibleTypeEnum } from '@/services/dtos/enums/accessAutomation.enum';
import { PasswordConfigurationTypeEnum } from '@/pages/tax/access-request/edit/components/config';

const passwordSchema = z.object({
  type: z.nativeEnum(PasswordConfigurationTypeEnum),
  value: z.string(),
});

export const accessSchema = z.object({
  term: z.object({
    user_name: z.string().min(1, "Nome do usuário é obrigatório"),
    cpf: z.string().min(11, "CPF inválido"),
    store_code: z.union([z.string(), z.number()]).transform((val) =>
      typeof val === 'string' ? val : String(val)
    ),
  }),
  config: z.object({
    userClassValue: z.nativeEnum(UserResponsibleTypeEnum),
    userPassword: passwordSchema.refine(
      (data) => data.type === PasswordConfigurationTypeEnum.AUTOMATIC || data.value.length >= 5,
      { message: "Senha de usuário deve ter pelo menos 5 caracteres" }
    ),
    operatorPassword: passwordSchema.refine(
      (data) => data.type === PasswordConfigurationTypeEnum.AUTOMATIC || data.value.length >= 5,
      { message: "Senha de operador deve ter pelo menos 5 caracteres" }
    ),
    setUserPasswordError: z.function().optional(),
    setOperatorPasswordError: z.function().optional(),
  }),
});

export type AccessSchemaType = z.infer<typeof accessSchema>;
